import { render, staticRenderFns } from "./commodityCounts.vue?vue&type=template&id=2a254f7c&scoped=true&"
import script from "./commodityCounts.vue?vue&type=script&lang=js&"
export * from "./commodityCounts.vue?vue&type=script&lang=js&"
import style0 from "./commodityCounts.vue?vue&type=style&index=0&id=2a254f7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a254f7c",
  null
  
)

component.options.__file = "commodityCounts.vue"
export default component.exports